


export const tipoStandard = (dataSemiologia) => {
  const sintomasList = dataSemiologia?.preguntas.sintomas;

  const sintomasListText = sintomasList.map( 
    (sintoma, index) => {

      const nombreSintoma = `${index + 1}. ${sintoma.text}`;

      const comienzo      = (sintoma.comienzoTipo )
        ? ` desde hace${sintoma.comienzoNumero ? ` ${sintoma.comienzoNumero}` : ''} ${sintoma.comienzoTipo?.text ? sintoma.comienzoTipo?.text : ''}`
        : '';
      
      const factores = sintoma.factores.length > 0 
        ? ` con posible causa de ${sintoma.factores.map( factor => factor.text ).join(', ').trim()}`
        : '';

      const tratamientos  = sintoma.tratamientos.length > 0 
        ? ` con tratamiento de ${sintoma.tratamientos.map( tratamiento => tratamiento.text ).join(', ').trim()}`
        : '';

      return `${nombreSintoma}${comienzo}${factores}${tratamientos}`
    }
  );
  
  const observaciones = dataSemiologia?.preguntas.observaciones;
  const observacionesText = observaciones.active ? `adicionalmente ${observaciones.text}` : '';

  return `con sintomas ${sintomasListText.map( item => `\n${item}; `).join('')} \n${observacionesText}`;
}